import { render, staticRenderFns } from "./SubmitForApproval.vue?vue&type=template&id=0bd5ce16"
import script from "./SubmitForApproval.vue?vue&type=script&lang=js"
export * from "./SubmitForApproval.vue?vue&type=script&lang=js"
import style0 from "./SubmitForApproval.vue?vue&type=style&index=0&id=0bd5ce16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports